import styled from "styled-components";

export const MoreDetailsProductContent = styled.div`
  position: fixed !important;
  inset: 0 !important;

  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  
  width: 60vw !important;
  max-height: 85vh !important;

  background: var(--black-200) !important;
  border-radius: 4px !important;
  border: none !important;
  padding: 0px !important;

  margin: auto;
`;

export const Header = styled.header`
  padding: 1rem 1.5rem;

  width: 100%;

  border-bottom: 1px solid rgba(82, 82, 82, 0.64);

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  img {
    cursor: pointer;
  }
`;

export const ActiveOverlay = styled.div`
  background-color: rgba(25, 25, 25, 0.75) !important;
  inset: 0;
  width: 100vw;
  height: 100vh;
  position: fixed;
`;

export const MoreDetailsContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  height: auto;

  header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 1.5rem;
    width: 100%;
    border-bottom: 1px solid rgba(82, 82, 82, 0.64);

    img {
      cursor: pointer;
    }
  }
`;

export const MoreContent = styled.div`
  width: 100%;
  height: 100%; 
  padding: 1.75rem;

  overflow-y: auto;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 1rem;
`;

export const Regions = styled.div`
  display: flex;
  flex-direction: row !important;
  border-bottom: 1px solid rgba(82, 82, 82, 0.64);
  padding-bottom: 0.5rem;
  margin-top: 0.5rem;
  justify-content: center;

  p {
    color: var(--primary);
    margin-left: auto;
  }

  &:last-of-type {
    border-bottom: none;
  }
`;
